import { useEffect, useRef } from 'react';

/** Thin gradient bar fixed to the very top of the viewport, its width tracking
 * how far down the current page you've scrolled. Cheap (one scroll listener,
 * one style write, no re-renders) and it's the kind of ambient orientation
 * cue long pages benefit from but this site had none of. */
export default function ScrollProgress() {
  const barRef = useRef(null);

  useEffect(() => {
    function update() {
      const doc = document.documentElement;
      const scrollable = doc.scrollHeight - doc.clientHeight;
      const pct = scrollable > 0 ? Math.min(100, (window.scrollY / scrollable) * 100) : 0;
      if (barRef.current) barRef.current.style.width = `${pct}%`;
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, []);

  return (
    <div className="scroll-progress-track">
      <div ref={barRef} className="scroll-progress-bar" />
    </div>
  );
}
